import { Injectable } from '@angular/core';
import {
  GetCommunicationLogGQL,
  GetCommunicationLogQueryVariables,
  Calldto,
  Voicemaildto,
} from '../../generated/eveportal-api/graphql';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallHistoryService {
  constructor(private getLogGQL: GetCommunicationLogGQL) {}

  getCallHistory(params: {
    limit: number;
    itemTypes?: string[] | null;
    search?: string;
    since?: number;
    olderThan?: number;
  }) {
    return this.getLogGQL.fetch(params, {fetchPolicy: 'network-only'}).pipe(
      map((result) => {
        const historyItems = result.data.communicationLog?.historyItems ?? [];
        return historyItems.map(item => item.callDTO ?? item.voiceMailDTO) as (Calldto | Voicemaildto)[];
      })
    );
  }
}